import script from "./AdminNewsletter.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNewsletter.vue?vue&type=script&setup=true&lang=js"

import "./AdminNewsletter.vue?vue&type=style&index=0&id=7fe3fc2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fe3fc2c"]])

export default __exports__